import { LAST_VIEW_KEY } from "@/hooks/useActiveView";

import { RECENT_SEARCHES_KEY } from "@/utils/URecentSearches";

/** The prefix of the subscription banners a user has dismissed. */
export const DISMISSED_BANNER_PREFIX = "subscription:banner:dismissed:";

/**
 * Forgets, at sign-out, what the browser kept about the person signed in:
 * their recent searches (client and project names), their last view, the
 * banners they dismissed, and the filters of the session. On a shared
 * computer the next person must not find them (docs/rgpd.md). The UI
 * language stays: it is the device's, not the person's.
 */
export const clearUserStorage = (): void => {
	try {
		localStorage.removeItem(RECENT_SEARCHES_KEY);
		localStorage.removeItem(LAST_VIEW_KEY);
		Object.keys(localStorage)
			.filter((key) => key.startsWith(DISMISSED_BANNER_PREFIX))
			.forEach((key) => localStorage.removeItem(key));
		// Filters (search text, client ids, dates) are written by
		// amphore-lib's createFiltersContext under this name.
		sessionStorage.removeItem("FiltersContext");
	} catch {
		// Storage unavailable (private mode, blocked): nothing was kept.
	}
};
